'use client'

import { Text, Dialog, Cell, Divider, InfoBanner } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { AddressModel } from '@marketplace-web/address/address-data'

import BillingAddress from '../../BillingAddress'
import { AddressScreenTrackingType } from '../../../constants'

type AddressType = 'billing' | 'residency'

type Props = {
  isOpen: boolean
  onChange: (adress: AddressModel) => void
  onCancel: () => void
  address?: AddressModel | null
  addressType?: AddressType
}

const EditAddressModal = ({
  isOpen,
  onChange,
  onCancel,
  address,
  addressType = 'billing',
}: Props) => {
  const billingTranslate = useTranslate('activate_balance.edit_billing_address')
  const residencyTranslate = useTranslate('activate_balance.edit_residency_address')

  const getTitle = () => {
    if (addressType === 'billing') return billingTranslate('title')
    if (addressType === 'residency') return residencyTranslate('title')

    return undefined
  }

  const renderInfoBanner = () => {
    if (addressType !== 'residency') return null

    return <InfoBanner body={residencyTranslate('info_banner.body')} />
  }

  return (
    <Dialog show={isOpen} testId="address-modal">
      <Cell>
        <Text
          as="h2"
          type={Text.Type.Title}
          alignment={Text.Alignment.Center}
          width={Text.Width.Parent}
          text={getTitle()}
        />
      </Cell>
      <Divider />
      {renderInfoBanner()}
      <BillingAddress
        address={address}
        screenTrackingType={AddressScreenTrackingType.SettingsBalanceActivation}
        onCancel={onCancel}
        onChange={onChange}
      />
    </Dialog>
  )
}

export default EditAddressModal
